import actions, { withProductLine } from '../../actions/GenericBenefitsSets'
import { connectPlanSharedBusinessRules } from '../PlanSharedBusinessRules/CreateBusinessRulesShow'

export default connectPlanSharedBusinessRules('Hospital Indemnity',
  withProductLine('hospital_indemnity', actions.show.main),
  actions.show.reset,
  true)
